
import { Inject, Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { DomainObjectRepo } from '../../noizu/domain-object-repo';
import { FirebaseAuthService }        from '../../noizu/services/firebase-auth.service';
import { AppengineRepo }      from '../appengine.repo';
import { GatewayLookupTableEntryEntity }      from '../../entities/gateway/lookup-table-entry.entity';

@Injectable()
export class GatewayLookupTableRepo extends AppengineRepo {
  public _kind = "gateway-lookup";
  public _singular = "gateway-lookup";

  constructor(@Inject(HttpClient) client: HttpClient, @Inject(FirebaseAuthService) auth: FirebaseAuthService) {
    super(client, auth);
  }

  entity(record) {
    return new GatewayLookupTableEntryEntity(this.client, this.auth, record)
  }
}
